<div *cdkDragPreview class="drag-and-drop-preview"
  [innerHtml]="label | escapeHtml">
</div>
<div *cdkDragPlaceholder class="drag-and-drop-placeholder"></div>